<template>
    <q-card>
        <q-card-title
            v-if="isNew">
            Zdefiniuj nowy szablon
        </q-card-title>
        <q-card-main v-if="isNew">
            Treść <q-input type="textarea" v-model="text"></q-input>
        </q-card-main>
        <q-card-main v-else-if="inEdit">
            <q-input type="textarea" v-model="model.text"></q-input>
        </q-card-main>
        <q-card-main v-else-if="prepareToSend">
            <q-input type="textarea" v-model="title" placeholder="Tytuł"></q-input>
            <q-input type="textarea" v-model="model.text"></q-input>
        </q-card-main>
        <q-card-main v-else>
            <q-input :readonly="true" type="textarea" v-model="model.text"></q-input>
        </q-card-main>

        <q-card-actions class="justify-end">
            <q-btn
                v-if="! isNew && ! prepareToSend"
                @click="$emit('remove')"
                icon="delete"/>

            <q-btn
                v-if="isNew || prepareToSend || inEdit"
                @click="cancel"
                label="Anuluj"/>
            <q-btn
                v-if="isNew"
                color="primary"
                @click="save"
                label="Dodaj"/>

            <q-btn
                v-if="inEdit"
                color="primary"
                @click="save"
                label="Zapisz"/>

            <q-btn
                v-if="! isNew && ! prepareToSend && ! inEdit"
                @click="inEdit = true"
                label="Edytuj"/>

            <q-btn
                v-if="! isNew && ! prepareToSend && !inEdit"
                color="primary"
                @click="prepareToSend = true"
                label="Skonfiguruj i wyślij"/>

            <q-btn
                v-if="prepareToSend"
                color="primary"
                @click="sendAndroid"
                label="Wyślij"/>

        </q-card-actions>


    </q-card>
</template>
<script>
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import QDatetime from 'quasar-framework/src/components/datetime/QDatetime'
    import QField from 'quasar-framework/src/components/field/QField'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import FixedButtons from './FixedButtons'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'

    export default {
        name: 'PushTemplate',
        props: ['isNew', 'model'],
        components: {
            QCardTitle,
            QTooltip, FixedButtons, QCardActions, QCardMain, QField, QDatetime, QChipsInput, QBtn, QEditor},
        data () {
            return {
                id: this.$uuid(),
                title: '',
                text: '',
                prepareToSend: false,
                inEdit: false
            }
        },
        methods: {
            cancel () {
                if (this.prepareToSend) {
                    this.prepareToSend = false
                } else if (this.inEdit){
                    this.inEdit = false
                } else {
                    this.$emit('cancel')
                }
            },
            save () {
                this.$emit('save', {
                    text: this.text,
                })
            },
            sendAndroid () {
                this.$emit('send', {
                    text: this.model.text,
                    title: this.title,
                    deviceType: 'android'
                })
            },
            sendiOS () {
                this.$emit('send', {
                    text: this.model.text,
                    title: this.title,
                    deviceType: 'ios'
                })
            },
        },
    }
</script>